import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Badge,
  Button,
  CardImg,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Edit, Trash2, ExternalLink } from "react-feather";
import "./Campaign.scss";
import "./style.css"

const PUBLIC_BASE_URL = (process.env.REACT_APP_FILE_BASE_URL || process.env.REACT_APP_BASE_URL || "http://localhost:4001").replace(/\/?$/, "/");

const BannerCard = ({ data, onEdit, onDelete, onToggleStatus, totalRows, perPage, currentPage, onPageChange }) => {
  // Calculate pagination
  const totalPages = Math.ceil(totalRows / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };


  return (
    <div>
      <div className="banner-grid-Sy4c">
        {data.map((banner) => (
          <Card key={banner._id} className="banner-card">
            {/* Card Header with Title & Status */}
            <CardHeader className="banner-header d-flex justify-content-between align-items-center">
              <h6 className="banner-title text-white text-truncate mb-0">{banner.title}</h6>
              <Badge
                style={{ color: "white" }}
                className="status-badge text-white text-capitalize"
                color={
                  banner.status === "approved"
                    ? "success"
                    : banner.status === "pending"
                      ? "warning"
                      : banner.status === "deactivated"
                        ? "danger"
                        : banner.status === "inactive"
                          ? "secondary"
                          : "light"
                }
              >
                {banner.status}
              </Badge>
            </CardHeader>

            {/* Image Preview */}
            <CardImg
              top
              src={`${PUBLIC_BASE_URL}/${banner.image}`}
              alt={banner.title}
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: "200px", objectFit: "cover" }}
            />

            {/* Card Body with Details */}
            <CardBody className="banner-body">
              <p className="banner-text">
                <strong>Banner Name:</strong> {banner.title}
              </p>
              <p className="banner-text">
                <strong>Arabic Name:</strong> {banner.titleAr || "N/A"}
              </p>
              <p className="banner-text text-capitalize">
                <strong>Type:</strong> {banner.bannerType || "N/A"}
              </p>
              <p className="banner-text">
                <strong>Views:</strong> {banner.views?.toLocaleString() || "0"}
              </p>
              <p className="banner-text">
                <strong>Clicks:</strong> {banner.clicks?.toLocaleString() || "0"}
              </p>
              {/* <p className="banner-text text-truncate">
                <strong>URL:</strong>{" "}
                <a href={banner.link} target="_blank" rel="noopener noreferrer">
                  {banner.link} <ExternalLink size={14} />
                </a>
              </p> */}

              {/* Action Buttons */}
              <div
                style={{
                  marginTop: "0.5rem",
                  display: "flex",
                  gap: "0.5rem",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  style={{
                    backgroundColor: "#17a2b8",
                    color: "#fff",
                    border: "none",
                    padding: "6px 12px",
                    fontSize: "0.875rem",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => onEdit(banner)}
                >
                  <Edit size={14} style={{ marginRight: "6px" }} /> Edit
                </button>

                <button
                  type="button"
                  style={{
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    padding: "6px 12px",
                    fontSize: "0.875rem",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => onDelete(banner._id)}
                >
                  <Trash2 size={14} style={{ marginRight: "6px" }} /> Delete
                </button>

                <label className="switch">
                  <input
                    type="checkbox"
                    checked={banner.status === "approved"}
                    onChange={() => onToggleStatus(banner._id)}
                    // disabled={banner.status === "pending" || banner.status === "declined"}
                    style={{
                      cursor:
                        banner.status === "approved" || banner.status === "deactivated"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    title={banner.status === "approved" ? "Deactivate" : "Activate"}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </CardBody>
          </Card>
        ))}
      </div>

      {/* Pagination */}
      {totalRows > 0 && (
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink first onClick={() => handlePageClick(1)} />
            </PaginationItem>
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
            </PaginationItem>
            {[...Array(totalPages).keys()].map((page) => (
              <PaginationItem key={page + 1} active={page + 1 === currentPage}>
                <PaginationLink onClick={() => handlePageClick(page + 1)}>
                  {page + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
            </PaginationItem>
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink last onClick={() => handlePageClick(totalPages)} />
            </PaginationItem>
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default BannerCard;